import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const FadeUp = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, mode = "load" }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          {...(mode === "load"
            ? { animate: { y: "0%" } }
            : { whileInView: { y: "0%" }, viewport: { once: true, margin: "-10% 0px" } })}
          transition={{ duration: 1.05, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Chapter = ({ num, label, className = "" }) => (
  <FadeUp className={`flex items-center gap-4 ${className}`} y={16}>
    <span className="font-mono text-[11px] tracking-[0.35em] text-glow/80">{num}</span>
    <span className="h-px w-14 bg-silver/25" />
    <span className="font-mono text-[11px] tracking-[0.35em] text-mist">{label}</span>
  </FadeUp>
);
